import { IChartDataSet } from '../../../../../Contracts/chart/IChartDataSet';
import { currencyFormatterNoDecimal } from '../../../../../Helpers/CurrencyFormatter';
import { Gender, RaceTypes } from '../../../../Model/Enum/BEE123Enums';
import { defaultObject } from '../../../../Model/helpers';
import { DashboardColour } from '../../../Constants/Colour/dashboardColour';
import { ResultWithValue } from '../../../Constants/Result/ResultWithValue';
import { IDoubleColumnChartData } from '../Base/DoubleColumnChart/IDoubleColumnChartData';
import { ICostAndHeadcountPerTrainingType } from './CostAndHeadcountPerTrainingType';

export const mapCostAndHeadcountTrainingTypeToDoubleColumnChartData = (
    isCost: boolean = true,
    requestData: ICostAndHeadcountPerTrainingType,
    trainingTypeFilter: Array<string>
): ResultWithValue<IDoubleColumnChartData> => {
    var data = requestData?.value ?? [];
    data = data.filter(x => trainingTypeFilter?.some(y => y === x.label));
    var labels = data.map((i) => [i.label]);

    const AfricanMale: IChartDataSet = {
        label: "African-Male",
        data: new Array(data.length).fill(0),
        backgroundColor: DashboardColour.AfricanMale
    };
    const AfricanFemale: IChartDataSet = {
        label: "African-Female",
        data: new Array(data.length).fill(0),
        backgroundColor: DashboardColour.AfricanFemale
    };
    const ColouredMale: IChartDataSet = {
        label: "Coloured-Male",
        data: new Array(data.length).fill(0),
        backgroundColor: DashboardColour.ColouredMale
    };
    const ColouredFemale: IChartDataSet = {
        label: "Coloured-Female",
        data: new Array(data.length).fill(0),
        backgroundColor: DashboardColour.ColouredFemale
    };
    const IndianMale: IChartDataSet = {
        label: "Indian-Male",
        data: new Array(data.length).fill(0),
        backgroundColor: DashboardColour.IndianMale
    };
    const IndianFemale: IChartDataSet = {
        label: "Indian-Female",
        data: new Array(data.length).fill(0),
        backgroundColor: DashboardColour.IndianFemale
    };
    const WhiteMale: IChartDataSet = {
        label: "White-Male",
        data: new Array(data.length).fill(0),
        backgroundColor: DashboardColour.WhiteMale
    };
    const WhiteFemale: IChartDataSet = {
        label: "White-Female",
        data: new Array(data.length).fill(0),
        backgroundColor: DashboardColour.WhiteFemale
    };
    const NonRSAMale: IChartDataSet = {
        label: "NonRSA-Male",
        data: new Array(data.length).fill(0),
        backgroundColor: DashboardColour.NonRSAMale
    };
    const NonRSAFemale: IChartDataSet = {
        label: "NonRSA-Female",
        data: new Array(data.length).fill(0),
        backgroundColor: DashboardColour.NonRSAFemale
    };

    for (let trainingTypeIndex = 0; trainingTypeIndex < data.length; trainingTypeIndex++) {
        const headcountsummaryitem = data[trainingTypeIndex];
        for (const series of headcountsummaryitem.series) {
            if (series.gender === Gender.Male && series.race === RaceTypes.African) {
                AfricanMale.data[trainingTypeIndex] = isCost ? series.costValue : series.headcountValue;
            }
            if (series.gender === Gender.Female && series.race === RaceTypes.African) {
                AfricanFemale.data[trainingTypeIndex] = isCost ? series.costValue : series.headcountValue;
            }

            if (series.gender === Gender.Male && series.race === RaceTypes.Coloured) {
                ColouredMale.data[trainingTypeIndex] = isCost ? series.costValue : series.headcountValue;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.Coloured) {
                ColouredFemale.data[trainingTypeIndex] = isCost ? series.costValue : series.headcountValue;
            }
            if (series.gender === Gender.Male && series.race === RaceTypes.Indian) {
                IndianMale.data[trainingTypeIndex] = isCost ? series.costValue : series.headcountValue;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.Indian) {
                IndianFemale.data[trainingTypeIndex] = isCost ? series.costValue : series.headcountValue;
            }

            if (series.gender === Gender.Male && series.race === RaceTypes.White) {
                WhiteMale.data[trainingTypeIndex] = isCost ? series.costValue : series.headcountValue;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.White) {
                WhiteFemale.data[trainingTypeIndex] = isCost ? series.costValue : series.headcountValue;
            }

            if (series.gender === Gender.Male && series.race === RaceTypes.NonRSA) {
                NonRSAMale.data[trainingTypeIndex] = isCost ? series.costValue : series.headcountValue;
            }

            if (series.gender === Gender.Female && series.race === RaceTypes.NonRSA) {
                NonRSAFemale.data[trainingTypeIndex] = isCost ? series.costValue : series.headcountValue;
            }
        }
    }

    const datasetsPerRaceGender: Array<IChartDataSet> = [
        AfricanMale.data.length > 0
            ? AfricanMale
            : defaultObject,
        AfricanFemale.data.length > 0
            ? AfricanFemale
            : defaultObject,
        ColouredMale.data.length > 0
            ? ColouredMale
            : defaultObject,
        ColouredFemale.data.length > 0
            ? ColouredFemale
            : defaultObject,
        IndianMale.data.length > 0
            ? IndianMale
            : defaultObject,
        IndianFemale.data.length > 0
            ? IndianFemale
            : defaultObject,
        WhiteMale.data.length > 0
            ? WhiteMale
            : defaultObject,
        WhiteFemale.data.length > 0
            ? WhiteFemale
            : defaultObject,
        NonRSAMale.data.length > 0
            ? NonRSAMale
            : defaultObject,
        NonRSAFemale.data.length > 0
            ? NonRSAFemale
            : defaultObject
    ].filter(i => i.label != null);

    return {
        isSuccess: true,
        errorMessage: '',
        value: {
            labels,
            datasets: datasetsPerRaceGender,
            valueFormatter: isCost ? currencyFormatterNoDecimal : undefined,
        }
    };
}